"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.urlFactory = void 0;
const qs_1 = require("./qs");
function urlFactory(base, endpoint = '', 
/* eslint-disable @typescript-eslint/no-explicit-any */
params = {}) {
    const apiUrl = process.env.NEXT_PUBLIC_API_URL;
    if (!apiUrl) {
        throw Error('NEXT_PUBLIC_API_URL not found');
    }
    const queryString = (0, qs_1.stringify)(params, { arrayFormat: 'comma', skipNull: true });
    return `${apiUrl}${base || ''}${endpoint}${queryString ? '?' + queryString : ''}`;
}
exports.urlFactory = urlFactory;
